import { render, staticRenderFns } from "./OpsBoard.vue?vue&type=template&id=43e18166&scoped=true"
import script from "./OpsBoard.vue?vue&type=script&lang=js"
export * from "./OpsBoard.vue?vue&type=script&lang=js"
import style0 from "./OpsBoard.vue?vue&type=style&index=0&id=43e18166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e18166",
  null
  
)

export default component.exports